<template>
  <!-- Loading Screen - DISABLED (change isLoading to ref(true) to re-enable) -->
  <!--
  <div v-if="isLoading" class="loading-screen">
    <div class="fullscreen-bg">
      <img 
        src="https://epiroc.scene7.com/is/image/epiroc/FlexiROC+T40+comm+quarry+1924?$landscape1600$&cropN=0.00,0.14,1.00,0.60" 
        alt="Epiroc FlexiROC T40" 
        class="bg-image"
        onerror="this.src='https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80'"
      />
      <div class="loading-overlay"></div>
    </div>
    
    <div class="loading-content">
      <div class="brand-section">
        <h1 class="brand-title">Aslan Energy</h1>
        <p class="brand-subtitle">{{ locale === 'tr' ? 'Maden ve Enerji Çözümleri' : 'Mining and Energy Solutions' }}</p>
      </div>
      
      <div class="progress-container">
        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: loadingProgress + '%' }"></div>
        </div>
        <p class="loading-text">{{ locale === 'tr' ? 'Yükleniyor...' : 'Loading...' }} {{ Math.floor(loadingProgress) }}%</p>
      </div>
    </div>
  </div>
  -->

  <div class="home-container" :class="{ 'page-loaded': !isLoading }">
    <!-- Parallax Background Elements -->
    <div class="parallax-container">
      <div class="parallax-bg parallax-bg-1" :style="{ transform: `translateY(${parallaxOffset1}px)` }"></div>
      <div class="parallax-bg parallax-bg-2" :style="{ transform: `translateY(${parallaxOffset2}px)` }"></div>
      <div class="parallax-bg parallax-bg-3" :style="{ transform: `translateY(${parallaxOffset3}px)` }"></div>
    </div>

    <!-- Hero Slider Component -->
    <HeroSlides :locale="locale" />
    <!-- Info Section Component -->
    <InfoSection :locale="locale" />

    <!-- Statistics Component -->
    <Statistics :locale="locale" />

        <!-- Machinery Section -->
        <MachinerySection :locale="locale" />

    <!-- Projects Section Component -->
    <ProjectsSection :locale="locale" />

    <!-- References Section -->
    <ReferencesSection :locale="locale" />

    <!-- Services Section Component -->
    <ServicesSection :locale="locale" />

    <!-- About Section Component -->
    <AboutSection :locale="locale" />

    <!-- News Section Component -->
    <NewsSection :locale="locale" />

    <!-- Home Footer Component -->
    <!-- Home Footer Component -->
    <HomeFooter :locale="locale" />


  </div>
</template><script setup>
import { ref, onMounted, onUnmounted, computed, watch } from 'vue'
import ApiService from '../services/api.js'
import ReferencesSection from '../components/ReferencesSection.vue'
import MachinerySection from '../components/MachinerySection.vue'
import HeroSlides from '../components/sections/HeroSlides.vue'
import Statistics from '../components/sections/Statistics.vue'
import InfoSection from '../components/sections/InfoSection.vue'
import ProjectsSection from '../components/sections/ProjectsSection.vue'
import ServicesSection from '../components/sections/ServicesSection.vue'
import AboutSection from '../components/sections/AboutSection.vue'
import NewsSection from '../components/sections/NewsSection.vue'
import HomeFooter from '../components/sections/HomeFooter.vue'
import '../css/main.css'

// Parallax effect variables
const parallaxOffset1 = ref(0)
const parallaxOffset2 = ref(0)
const parallaxOffset3 = ref(0)

// Scroll event handler for parallax effect
const handleScroll = () => {
  const scrollY = window.scrollY
  // Different speeds for different layers
  parallaxOffset1.value = scrollY * 0.3
  parallaxOffset2.value = scrollY * 0.5
  parallaxOffset3.value = scrollY * 0.7
}

// Props from App.vue
const props = defineProps({
  locale: String
})

// Emits to App.vue
const emit = defineEmits(['changeLanguage', 'navigate'])

// Language management - props'tan geliyor
const locale = computed(() => props.locale)

// Language switching - emit to parent
const changeLanguage = async (lang) => {
  try {
    // Emit to parent (App.vue) - bu locale değerini güncelleyecek
    emit('changeLanguage', lang)
    
    // console.log(`✓ Language changed to ${lang}`)
    // Not: API verilerini yeniden yükleme watch(locale) tarafından otomatik olarak yapılacak
  } catch (error) {
    // console.error('Error changing language:', error)
  }
}

// API Data - Reactive references
const heroSlidesData = ref([])
const newsData = ref([])
const projects = ref([])
const services = ref([])
const infoCards = ref([])

// Info Cards verilerini güncelleme fonksiyonu
const updateInfoCards = () => {
  infoCards.value = [
    {
      id: 1,
      type: 'yellow-card',
      title: locale.value === 'tr' ? 'Güneş Enerjisi Sistemleri' : 'Solar Energy Systems',
      description: locale.value === 'tr' ? 'Ev ve işyerleriniz için yüksek verimli güneş paneli sistemleri. Temiz enerji ile hem çevreyi koruyun hem de elektrik faturalarınızı azaltın.' : 'High-efficiency solar panel systems for homes and businesses. Protect the environment and reduce your electricity bills with clean energy.',
      buttonText: locale.value === 'tr' ? 'Keşfet' : 'Explore'
    },
    {
      id: 2,
      type: 'black-card',
      title: locale.value === 'tr' ? 'Enerji Depolama' : 'Energy Storage',
      description: locale.value === 'tr' ? 'Gelişmiş batarya teknolojileri ile ürettiğiniz enerjiyi depolayın. Kesintisiz güç sağlayın ve enerji bağımsızlığınızı artırın.' : 'Store your generated energy with advanced battery technologies. Provide uninterrupted power and increase your energy independence.',
      buttonText: locale.value === 'tr' ? 'Detaylar' : 'Details'
    },
    {
      id: 3,
      type: 'image-card',
      title: locale.value === 'tr' ? 'Uzman Danışmanlık' : 'Expert Consulting',
      description: locale.value === 'tr' ? 'Alanında uzman ekibimizle size özel enerji çözümleri geliştiriyoruz. Proje planlamadan kuruluma kadar her aşamada yanınızdayız.' : 'We develop customized energy solutions with our expert team. We are with you at every stage from project planning to installation.',
      buttonText: locale.value === 'tr' ? 'İletişim' : 'Contact',
      backgroundImage: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
  ]
}
const featureCards = ref([])
const aboutFeatures = ref([])
const missionVisionCards = ref([])
const isLoadingData = ref(false)

// Image loading control system
const failedImages = new Set()
const loadingImages = new Set()
const imageCache = new Map()
const maxRetries = 2
const retryDelay = 1000

// Default fallback images
const defaultImages = {
  project: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  news: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  machinery: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  placeholder: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}



// API Data Loading Functions
const loadHeroSlides = async () => {
  try {
    const slides = await ApiService.getHeroSlides();
    if (slides && slides.length > 0) {
      heroSlidesData.value = slides.map(slide => ({
        id: slide.id,
        title: locale.value === 'tr' ? slide.title_tr : slide.title_en,
        description: locale.value === 'tr' ? slide.description_tr : slide.description_en,
        backgroundImage: slide.image_url,
        primaryButtonText: locale.value === 'tr' ? slide.button_text_tr : slide.button_text_en,
        secondaryButtonText: locale.value === 'tr' ? "İletişime Geçin" : "Contact Us",
        primaryAction: slide.button_action || "contact",
        secondaryAction: "contact"
      }));
    }
  } catch (error) {
    // console.error('Hero slides yüklenemedi:', error);
  }
};



const loadNews = async () => {
  try {
    // console.log('🔄 Loading news data...');
    const news = await ApiService.getNews({ limit: 3 });
    // console.log('📰 News API response:', news);
    
    if (news && news.length > 0) {
      newsData.value = news.map(article => {
        const rawImageUrl = article.image_url || article.image
        const processedUrl = ApiService.getImageUrl(rawImageUrl, defaultImages.news)
        const safeImageUrl = getSafeImageUrl(processedUrl, 'news')
        
        // console.log(`📰 News ${article.id} image:`, rawImageUrl, '→', safeImageUrl);
        
        return {
          id: article.id,
          title: locale.value === 'tr' ? article.title_tr : article.title_en,
          excerpt: locale.value === 'tr' ? article.excerpt_tr : article.excerpt_en,
          image: safeImageUrl,
          date: article.formatted_date || new Date().toLocaleDateString('tr-TR'),
          slug: article.slug
        };
      });
      console.log('✅ News data loaded:', newsData.value.length, 'articles');
    } else {
      console.warn('⚠️ No news data received, using fallback');
      // Fallback test data
      newsData.value = [
        {
          id: 1,
          title: locale.value === 'tr' ? 'Güneş Enerjisi Sektöründe Yeni Gelişmeler' : 'New Developments in Solar Energy',
          excerpt: locale.value === 'tr' ? 'Türkiye\'de güneş enerjisi yatırımları artmaya devam ediyor.' : 'Solar energy investments continue to increase in Turkey.',
          image: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          date: '15.10.2025',
          slug: 'gunes-enerjisi-gelismeler'
        },
        {
          id: 2,
          title: locale.value === 'tr' ? 'Yeni Projemiz Tamamlandı' : 'Our New Project Completed',
          excerpt: locale.value === 'tr' ? 'İstanbul\'da büyük ölçekli güneş enerjisi projemiz başarıyla tamamlandı.' : 'Our large-scale solar energy project in Istanbul has been successfully completed.',
          image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          date: '10.10.2025',
          slug: 'yeni-proje-tamamlandi'
        },
        {
          id: 3,
          title: locale.value === 'tr' ? 'Teknoloji Ortaklığı' : 'Technology Partnership',
          excerpt: locale.value === 'tr' ? 'Avrupa\'nın önde gelen teknoloji şirketi ile ortaklık imzaladık.' : 'We signed a partnership with Europe\'s leading technology company.',
          image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          date: '05.10.2025',
          slug: 'teknoloji-ortakligi'
        }
      ];
    }
  } catch (error) {
    console.error('❌ Haberler yüklenemedi:', error);
    // Hata durumunda da fallback göster
    newsData.value = [
      {
        id: 1,
        title: locale.value === 'tr' ? 'Güneş Enerjisi Sektöründe Yeni Gelişmeler' : 'New Developments in Solar Energy',
        excerpt: locale.value === 'tr' ? 'Türkiye\'de güneş enerjisi yatırımları artmaya devam ediyor.' : 'Solar energy investments continue to increase in Turkey.',
        image: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        date: '15.10.2025',
        slug: 'gunes-enerjisi-gelismeler'
      }
    ];
  }
};

const loadProjects = async () => {
  try {
    console.log('🔄 Loading projects data...');
    const response = await ApiService.getProjects({ limit: 20, page: 1 }); // 6 adet proje için
    console.log('🏗️ Projects API response:', response);
    
    // API response formatını kontrol et ve doğru veriyi al
    let projectsData = null;
    if (response && response.data && Array.isArray(response.data)) {
      projectsData = response.data;
    } else if (response && Array.isArray(response)) {
      projectsData = response;
    }
    
    if (projectsData && projectsData.length > 0) {
      projects.value = projectsData.map(project => {
        const rawImageUrl = project.image_url || project.image
        const processedUrl = ApiService.getImageUrl(rawImageUrl, defaultImages.project)
        const safeImageUrl = getSafeImageUrl(processedUrl, 'project')
        
        console.log(`📸 Project ${project.id} image:`, rawImageUrl, '→', safeImageUrl);
        
        return {
          id: project.id,
          title: locale.value === 'tr' ? project.title_tr : project.title_en,
          description: locale.value === 'tr' ? project.description_tr : project.description_en,
          image: safeImageUrl,
          capacity: project.capacity,
          location: locale.value === 'tr' ? project.location_tr : project.location_en,
          category: project.category,
          completionDate: project.completion_date,
          isFeatured: project.is_featured
        };
      });
      console.log('✅ Projects data loaded:', projects.value.length, 'projects');
    } else {
      console.warn('⚠️ No projects data received, using fallback');
      // Fallback projects data - 6 adet
      projects.value = [
        {
          id: 1,
          title: locale.value === 'tr' ? 'Güneş Enerjisi Santrali - Ankara' : 'Solar Power Plant - Ankara',
          description: locale.value === 'tr' ? 'Ankara\'da kurulmuş 5MW kapasiteli güneş enerjisi santrali' : 'Ankara\'da kurulmuş 5MW kapasiteli güneş enerjisi santrali',
          image: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          capacity: '5 MW',
          location: 'Ankara',
          category: 'solar',
          completionDate: '2024-10-15',
          isFeatured: true
        },
        {
          id: 2,
          title: locale.value === 'tr' ? 'Rüzgar Enerjisi Projesi - İzmir' : 'Wind Energy Project - Izmir',
          description: locale.value === 'tr' ? 'İzmir\'de 10MW kapasiteli rüzgar enerjisi projesi' : 'İzmir\'de 10MW kapasiteli rüzgar enerjisi projesi',
          image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          capacity: '10 MW',
          location: 'İzmir',
          category: 'wind',
          completionDate: '2024-09-20',
          isFeatured: true
        },
        {
          id: 3,
          title: locale.value === 'tr' ? 'Hibrit Enerji Sistemi - İstanbul' : 'Hybrid Energy System - Istanbul',
          description: locale.value === 'tr' ? 'İstanbul\'da güneş ve rüzgar enerjisinin birleştiği hibrit sistem' : 'İstanbul\'da güneş ve rüzgar enerjisinin birleştiği hibrit sistem',
          image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          capacity: '7.5 MW',
          location: 'İstanbul',
          category: 'hybrid',
          completionDate: '2024-08-10',
          isFeatured: true
        },
        {
          id: 4,
          title: locale.value === 'tr' ? 'Çatı Üstü GES - Bursa' : 'Rooftop Solar - Bursa',
          description: locale.value === 'tr' ? 'Bursa\'da fabrika çatısı üzerine kurulmuş 2MW GES' : 'Bursa\'da fabrika çatısı üzerine kurulmuş 2MW GES',
          image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          capacity: '2 MW',
          location: 'Bursa',
          category: 'solar',
          completionDate: '2024-07-15',
          isFeatured: true
        },
        {
          id: 5,
          title: locale.value === 'tr' ? 'Hibrit Enerji Sistemi - İstanbul' : 'Hybrid Energy System - Istanbul',
          description: locale.value === 'tr' ? 'İstanbul\'da güneş ve rüzgar enerjisinin birleştiği hibrit sistem' : 'İstanbul\'da güneş ve rüzgar enerjisinin birleştiği hibrit sistem',
          image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          capacity: '7.5 MW',
          location: 'İstanbul',
          category: 'hybrid',
          completionDate: '2024-06-20',
          isFeatured: true
        },
        {
          id: 6,
          title: locale.value === 'tr' ? 'Çatı Üstü GES - Bursa' : 'Rooftop Solar - Bursa',
          description: locale.value === 'tr' ? 'Bursa\'da fabrika çatısı üzerine kurulmuş 2MW GES' : 'Bursa\'da fabrika çatısı üzerine kurulmuş 2MW GES',
          image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          capacity: '2 MW',
          location: 'Bursa',
          category: 'solar',
          completionDate: '2024-05-10',
          isFeatured: true
        }
      ];
    }
  } catch (error) {
    console.error('Projeler yüklenemedi:', error);
    // Error durumunda fallback data
    projects.value = [
      {
        id: 1,
        title: locale.value === 'tr' ? 'Güneş Enerjisi Santrali' : 'Solar Power Plant',
        description: locale.value === 'tr' ? 'Yenilenebilir enerji çözümlerimizle sürdürülebilir bir gelecek inşa ediyoruz.' : 'Building a sustainable future with our renewable energy solutions.',
        image: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        capacity: '500 kW',
        location: locale.value === 'tr' ? 'İstanbul' : 'Istanbul',
        category: 'solar',
        completionDate: '2024-10-15',
        isFeatured: true
      },
      {
        id: 2,
        title: locale.value === 'tr' ? 'Rüzgar Enerjisi Projesi' : 'Wind Energy Project',
        description: locale.value === 'tr' ? 'Rüzgar enerjisi ile temiz elektrik üretimi sağlayan modern çözümler.' : 'Modern solutions providing clean electricity generation with wind energy.',
        image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        capacity: '750 kW',
        location: locale.value === 'tr' ? 'Ankara' : 'Ankara',
        category: 'wind',
        completionDate: '2024-09-20',
        isFeatured: true
      },
      {
        id: 3,
        title: locale.value === 'tr' ? 'Hibrit Enerji Sistemi' : 'Hybrid Energy System',
        description: locale.value === 'tr' ? 'Güneş ve rüzgar enerjisini birleştiren akıllı hibrit çözümler.' : 'Smart hybrid solutions combining solar and wind energy.',
        image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        capacity: '1 MW',
        location: locale.value === 'tr' ? 'İzmir' : 'Izmir',
        category: 'hybrid',
        completionDate: '2024-11-15',
        isFeatured: false
      }
    ];
  }
};

const loadServices = async () => {
  try {
    console.log('🔄 Loading services data...');
    const servicesData = await ApiService.getServices();
    console.log('⚙️ Services API response:', servicesData);
    
    if (servicesData && servicesData.length > 0) {
      services.value = servicesData.map(service => ({
        id: service.id,
        title: locale.value === 'tr' ? service.title_tr : service.title_en,
        description: locale.value === 'tr' ? service.description_tr : service.description_en,
        icon: service.icon || '⚡',
        features: service.features ? JSON.parse(service.features) : [],
        price: service.price
      }));
      console.log('✅ Services data loaded:', services.value.length, 'services');
    } else {
      console.warn('⚠️ No services data received, using fallback');
      // Fallback services data
      services.value = [
        {
          id: 1,
          title: locale.value === 'tr' ? 'Güneş Paneli Kurulumu' : 'Solar Panel Installation',
          description: locale.value === 'tr' ? 'Profesyonel güneş paneli kurulum hizmeti' : 'Professional solar panel installation service',
          icon: '☀️',
          features: [],
          price: null
        },
        {
          id: 2,
          title: locale.value === 'tr' ? 'Rüzgar Enerjisi' : 'Wind Energy',
          description: locale.value === 'tr' ? 'Rüzgar türbini kurulum ve bakım hizmeti' : 'Wind turbine installation and maintenance service',
          icon: '💨',
          features: [],
          price: null
        }
      ];
    }
  } catch (error) {
    console.error('❌ Hizmetler yüklenemedi:', error);
    // Hata durumunda fallback data
    services.value = [
      {
        id: 1,
        title: locale.value === 'tr' ? 'Güneş Paneli Kurulumu' : 'Solar Panel Installation',
        description: locale.value === 'tr' ? 'Profesyonel güneş paneli kurulum hizmeti' : 'Professional solar panel installation service',
        icon: '☀️',
        features: [],
        price: null
      }
    ];
  }
};

const loadStatistics = async () => {
  try {
    console.log('🔄 Loading statistics data...');
    const statisticsData = await ApiService.getStatistics();
    console.log('📊 Statistics API response:', statisticsData);
    
    if (statisticsData && statisticsData.length > 0) {
      statItems.value = statisticsData.map(stat => ({
        value: parseInt(stat.value) || 0,
        suffix: stat.suffix || '',
        label_tr: stat.label_tr || stat.label,
        label_en: stat.label_en || stat.label,
        icon: stat.icon || 'fas fa-chart-line'
      }));
      console.log('✅ Statistics data loaded:', statItems.value.length, 'statistics');
      console.log('📊 First stat item:', statItems.value[0]);
    } else {
      console.warn('⚠️ No statistics data received, using fallback');
      // Fallback statistics data
      statItems.value = [
        {
          value: 150,
          suffix: '+',
          label_tr: 'Tamamlanan Proje',
          label_en: 'Completed Projects',
          icon: 'fas fa-project-diagram'
        },
        {
          value: 500,
          suffix: 'MW',
          label_tr: 'Kurulu Güç',
          label_en: 'Installed Capacity',
          icon: 'fas fa-bolt'
        },
        {
          value: 12,
          suffix: '+',
          label_tr: 'Yıllık Deneyim',
          label_en: 'Years Experience',
          icon: 'fas fa-calendar-alt'
        },
        {
          value: 95,
          suffix: '%',
          label_tr: 'Müşteri Memnuniyeti',
          label_en: 'Customer Satisfaction',
          icon: 'fas fa-smile'
        }
      ];
    }
  } catch (error) {
    console.error('❌ İstatistikler yüklenemedi:', error);
    console.log('🔧 Using fallback statistics data');
    // Hata durumunda fallback data
    statItems.value = [
      {
        value: 150,
        suffix: '+',
        label_tr: 'Tamamlanan Proje',
        label_en: 'Completed Projects',
        icon: 'fas fa-project-diagram'
      },
      {
        value: 500,
        suffix: 'MW',
        label_tr: 'Kurulu Güç',
        label_en: 'Installed Capacity',
        icon: 'fas fa-bolt'
      },
      {
        value: 12,
        suffix: '+',
        label_tr: 'Yıllık Deneyim',
        label_en: 'Years Experience',
        icon: 'fas fa-calendar-alt'
      },
      {
        value: 95,
        suffix: '%',
        label_tr: 'Müşteri Memnuniyeti',
        label_en: 'Customer Satisfaction',
        icon: 'fas fa-smile'
      }
    ];
    console.log('🔧 Fallback statistics loaded:', statItems.value.length, 'items');
    console.log('🔧 First fallback item:', statItems.value[0]);
  }
};

const loadAboutFeatures = async () => {
  try {
    const aboutFeaturesData = await ApiService.getAboutFeatures();
    if (aboutFeaturesData && aboutFeaturesData.length > 0) {
      aboutFeatures.value = aboutFeaturesData.map(feature => ({
        title_tr: feature.title_tr,
        title_en: feature.title_en,
        description_tr: feature.description_tr,
        description_en: feature.description_en,
        icon_url: feature.icon_url,
        icon_svg: feature.icon_svg
      }));
    }
  } catch (error) {
    console.error('About features yüklenemedi:', error);
  }
};

const loadMissionVisionCards = async () => {
  try {
    const missionVisionData = await ApiService.getMissionVisionCards();
    if (missionVisionData && missionVisionData.length > 0) {
      missionVisionCards.value = missionVisionData.map(card => ({
        title_tr: card.title_tr,
        title_en: card.title_en,
        description_tr: card.description_tr,
        description_en: card.description_en,
        background_image: card.background_image,
        icon_url: card.icon_url,
        icon_svg: card.icon_svg
      }));
    }
  } catch (error) {
    console.error('Mission Vision cards yüklenemedi:', error);
  }
};

const loadApiData = async () => {
  isLoadingData.value = true;
  try {
    console.log('Loading API data...');
    await Promise.all([
      loadHeroSlides(),
      loadNews(),
      loadAboutFeatures(),
      loadMissionVisionCards(),
      loadProjects(),
      loadServices(),
      loadStatistics()
    ]);
    console.log('API data loaded successfully');
  } catch (error) {
    console.error('Error loading API data:', error);
  } finally {
    isLoadingData.value = false;
  }
}



// Project detail navigation - basit URL yönlendirme
const goToProjectDetail = (projectId) => {
  window.location.href = `?page=project&id=${projectId}`
}

const goToAllProjects = () => {
  console.log('🔍 Navigating to all projects page')
  // Projeler sayfasına yönlendirme
  window.location.href = '?page=projects'
}

// Advanced image error handling with retry mechanism
const handleImageError = (event, imageType = 'placeholder') => {
  const originalSrc = event.target.src
  const retryCount = event.target.dataset.retryCount || '0'
  const currentRetries = parseInt(retryCount)
  
  console.warn(`🖼️ Resim yüklenemedi (${currentRetries + 1}/${maxRetries}):`, originalSrc)
  
  // Mark as failed to prevent infinite loops
  failedImages.add(originalSrc)
  loadingImages.delete(originalSrc)
  
  // If we haven't reached max retries and it's not a default image
  if (currentRetries < maxRetries && !originalSrc.includes('unsplash.com') && !originalSrc.includes('placeholder')) {
    event.target.dataset.retryCount = (currentRetries + 1).toString()
    
    // Retry with delay
    setTimeout(() => {
      if (!failedImages.has(originalSrc)) {
        event.target.src = originalSrc + '?retry=' + (currentRetries + 1)
      } else {
        setFallbackImage(event.target, imageType)
      }
    }, retryDelay * (currentRetries + 1))
  } else {
    // Use fallback image
    setFallbackImage(event.target, imageType)
  }
}

// Set appropriate fallback image
const setFallbackImage = (imgElement, imageType) => {
  const fallbackUrl = defaultImages[imageType] || defaultImages.placeholder
  
  // Prevent setting the same URL again
  if (imgElement.src !== fallbackUrl) {
    imgElement.src = fallbackUrl
    imgElement.dataset.retryCount = '0'
    console.log(`🔄 Fallback image set for ${imageType}:`, fallbackUrl)
  }
}

// Check if image URL is valid and not failed before
const isValidImageUrl = (url) => {
  if (!url) return false
  if (failedImages.has(url)) return false
  if (loadingImages.has(url)) return false
  return true
}

// Safe image URL getter with validation
const getSafeImageUrl = (imageUrl, imageType = 'placeholder') => {
  // If URL is already cached as working, use it
  if (imageCache.has(imageUrl) && imageCache.get(imageUrl) === 'success') {
    return imageUrl
  }
  
  // If URL is in failed list, return fallback immediately
  if (failedImages.has(imageUrl)) {
    return defaultImages[imageType] || defaultImages.placeholder
  }
  
  // If no URL provided, return fallback
  if (!imageUrl) {
    return defaultImages[imageType] || defaultImages.placeholder
  }
  
  // Mark as loading
  loadingImages.add(imageUrl)
  return imageUrl
}



// Lazy Loading for Images
const initLazyLoading = () => {
  imageObserver.value = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target
          const src = img.getAttribute('data-src')
          if (src) {
            img.src = src
            img.removeAttribute('data-src')
            imageObserver.value.unobserve(img)
          }
        }
      })
    },
    { 
      threshold: 0.1,
      rootMargin: '50px'
    }
  )

  // Observe all lazy images
  setTimeout(() => {
    const lazyImages = document.querySelectorAll('img[data-src]')
    lazyImages.forEach((img) => {
      imageObserver.value.observe(img)
    })
  }, 100)
}

const projectCards = ref([])
const isMenuOpen = ref(false)
const isLoading = ref(false) // Loading disabled - change to ref(true) to re-enable
const loadingProgress = ref(0)

const statItems = ref([])
const isDarkMode = ref(false)
const currentSlide = ref(0)
const slideInterval = ref(null)
const imageObserver = ref(null)



// Hero Slider Data - API ile entegre
const heroSlides = computed(() => {
  // API'den gelen veri varsa onu kullan
  if (heroSlidesData.value && heroSlidesData.value.length > 0) {
    return heroSlidesData.value
  }
  
  // Son fallback: static data
  return [
    {
      id: 1,
      title: locale.value === 'tr' ? "Temiz Enerji Çözümleri" : "Clean Energy Solutions",
      description: locale.value === 'tr' ? "Sürdürülebilir gelecek için yenilenebilir enerji sistemleri" : "Renewable energy systems for a sustainable future",
      backgroundImage: "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
      primaryButtonText: locale.value === 'tr' ? "Daha Fazla Bilgi" : "Learn More",
      secondaryButtonText: locale.value === 'tr' ? "İletişime Geçin" : "Contact Us",
      primaryAction: "quote",
      secondaryAction: "contact"
    },
    {
      id: 2,
      title: locale.value === 'tr' ? "Güneş Enerjisi Sistemleri" : "Solar Energy Systems",
      description: locale.value === 'tr' ? "Profesyonel kurulum ve uzman hizmetiyle güneş paneli çözümleri" : "Professional solar panel solutions with expert installation",
      backgroundImage: "https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
      primaryButtonText: locale.value === 'tr' ? "Daha Fazla Bilgi" : "Learn More",
      secondaryButtonText: locale.value === 'tr' ? "İletişime Geçin" : "Contact Us",
      primaryAction: "calculator",
      secondaryAction: "survey"
    },
    {
      id: 3,
      title: locale.value === 'tr' ? "Enerji Verimliliği" : "Energy Efficiency",
      description: locale.value === 'tr' ? "Akıllı enerji yönetimi ile maliyet tasarrufu sağlayın" : "Save costs with smart energy management",
      backgroundImage: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
      primaryButtonText: locale.value === 'tr' ? "Daha Fazla Bilgi" : "Learn More",
      secondaryButtonText: locale.value === 'tr' ? "İletişime Geçin" : "Contact Us",
      primaryAction: "start",
      secondaryAction: "references"
    },
    {
      id: 4,
      title: locale.value === 'tr' ? "Çevreci Teknolojiler" : "Eco-Friendly Technologies",
      description: locale.value === 'tr' ? "Çevre dostu enerji çözümleriyle doğayı koruyun" : "Protect nature with environmentally friendly energy solutions",
      backgroundImage: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
      primaryButtonText: locale.value === 'tr' ? "Daha Fazla Bilgi" : "Learn More",
      secondaryButtonText: locale.value === 'tr' ? "İletişime Geçin" : "Contact Us",
      primaryAction: "stories",
      secondaryAction: "contact"
    }
  ]
})



// News Articles - API ile entegre
const newsArticles = computed(() => {
  // API'den gelen veri varsa onu kullan
  if (newsData.value && newsData.value.length > 0) {
    return newsData.value
  }
  
  // Boş array döndür (API yüklenirken)
  return []
})

// Featured Projects - Ana sayfada sadece ilk 6 tanesini göster
const featuredProjects = computed(() => {
  return projects.value.slice(0, 6)
})

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

const closeMenu = () => {
  isMenuOpen.value = false
}

const smoothScrollTo = (targetId) => {
  const element = document.querySelector(targetId)
  if (element) {
    element.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    })
  }
  closeMenu()
}

// Dark Mode Functions
const toggleDarkMode = () => {
  isDarkMode.value = !isDarkMode.value
  localStorage.setItem('darkMode', isDarkMode.value.toString())
  updateTheme()
}

const updateTheme = () => {
  if (isDarkMode.value) {
    document.documentElement.classList.add('dark-mode')
  } else {
    document.documentElement.classList.remove('dark-mode')
  }
}

const initDarkMode = () => {
  const savedMode = localStorage.getItem('darkMode')
  if (savedMode === 'true') {
    isDarkMode.value = true
    updateTheme()
  }
}

// Slider Functions
const nextSlide = () => {
  currentSlide.value = (currentSlide.value + 1) % heroSlides.value.length
}

const prevSlide = () => {
  currentSlide.value = currentSlide.value === 0 
    ? heroSlides.value.length - 1 
    : currentSlide.value - 1
}

const goToSlide = (index) => {
  currentSlide.value = index
}

const startSlideShow = () => {
  slideInterval.value = setInterval(() => {
    nextSlide()
  }, 8000) // 8 saniyede bir otomatik geçiş
}

const stopSlideShow = () => {
  if (slideInterval.value) {
    clearInterval(slideInterval.value)
    slideInterval.value = null
  }
}

const handleSlideAction = (action) => {
  switch(action) {
    case 'quote':
      // Teklif alma sayfasına yönlendir
      document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })
      break
    case 'projects':
      // Projeler bölümüne kaydır
      document.querySelector('.projects-section').scrollIntoView({ behavior: 'smooth' })
      break
    case 'calculator':
      // Hesaplama modülü açılacak (gelecekte eklenecek)
      alert('Tasarruf hesaplayıcısı yakında eklenecek!')
      break
    case 'survey':
      // Ücretsiz keşif formu
      document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })
      break
    case 'start':
      // Başlangıç süreci
      document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })
      break
    case 'references':
      // Referanslar sayfası
      document.querySelector('.projects-section').scrollIntoView({ behavior: 'smooth' })
      break
    case 'stories':
      // Başarı hikayeleri
      document.querySelector('.statistics-section').scrollIntoView({ behavior: 'smooth' })
      break
    case 'contact':
      // İletişim
      document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })
      break
    default:
      console.log('Action not defined:', action)
  }
}





// Statistics Animation
const animateStats = () => {
  const statNumbers = document.querySelectorAll('.stat-number')
  
  statNumbers.forEach((stat) => {
    const target = parseInt(stat.getAttribute('data-target'))
    const increment = target / 100
    let current = 0
    
    const updateNumber = () => {
      if (current < target) {
        current += increment
        stat.textContent = Math.ceil(current)
        setTimeout(updateNumber, 20)
      } else {
        stat.textContent = target
      }
    }
    
    updateNumber()
  })
}

// SEO features temporarily removed for successful build

// SEO Meta Data için computed - temporarily disabled for build
// const metaData = computed(() => {
//   const isEn = locale.value === 'en'
//   return {
//     title: isEn 
//       ? 'Aslan Energy - Solar Energy & Mining Machinery Solutions'
//       : 'Aslan Energy - Güneş Enerjisi ve Maden Makineleri Çözümleri',
//     meta: [
//       {
//         name: 'description',
//         content: isEn
//           ? 'Leading provider of solar energy systems, mining machinery and industrial solutions in Turkey. Epiroc equipment sales, service and spare parts.'
//           : 'Türkiye\'nin önde gelen güneş enerjisi sistemleri, maden makineleri ve endüstriyel çözümler sağlayıcısı. Epiroc makine satışı, servis ve yedek parça hizmetleri.'
//       },
//       {
//         name: 'keywords',
//         content: isEn
//           ? 'solar energy, solar panels, mining machinery, epiroc, epiroc t40, epiroc t35, flexiroc t40, flexiroc t35, drilling equipment, excavator rental, machinery rental, energy solutions, industrial equipment, mining equipment, construction machinery, spare parts, service, solar panel installation, renewable energy, clean energy, photovoltaic, inverter, battery storage, smart grid, net metering, turkey, istanbul, ankara, izmir'
//           : 'güneş enerjisi, solar panel, maden makineleri, epiroc, epiroc t40, epiroc t35, flexiroc t40, flexiroc t35, delgi makineleri, sondaj makineleri, makine kiralama, ekskavatör kiralama, dozer kiralama, enerji çözümleri, endüstriyel ekipman, maden ekipmanları, inşaat makineleri, yedek parça, servis hizmetleri, güneş paneli kurulumu, enerji sistemleri, yenilenebilir enerji, temiz enerji, fotovoltaik, inverter, enerji depolama, akıllı şebeke, türkiye, istanbul, ankara, izmir, bursa, antalya'
//       },
//       {
//         property: 'og:title',
//         content: isEn
//           ? 'Aslan Energy - Solar Energy & Mining Machinery'
//           : 'Aslan Energy - Güneş Enerjisi ve Maden Makineleri'
//       },
//       {
//         property: 'og:description',
//         content: isEn
//           ? 'Leading provider of solar energy and mining machinery solutions in Turkey.'
//           : 'Türkiye\'nin önde gelen güneş enerjisi ve maden makineleri şirketi.'
//       }
//     ],
//     canonical: 'https://aslanenergy.com.tr',
//     structuredData: [
//       getCompanyStructuredData(locale.value),
//       getWebsiteStructuredData(locale.value),
//       getServiceStructuredData(locale.value)
//     ]
//   }
// })

// Initialize SEO - temporarily disabled
// const initSEO = () => {
//   if (typeof window !== 'undefined' && metaData.value) {
//     useMeta(metaData)
//   }
// }

onMounted(async () => {
  // Initialize SEO after mount - temporarily disabled
  // initSEO()
  // Initialize dark mode
  initDarkMode()
  

  
  // Initialize lazy loading
  initLazyLoading()
  
  // Start hero slider immediately (not waiting for loading)
  startSlideShow()
  
  // Loading progress animation - DISABLED (uncomment to re-enable)
  /*
  const progressInterval = setInterval(() => {
    if (loadingProgress.value < 100) {
      loadingProgress.value += Math.random() * 20 + 15 // Random increment between 15-35
      if (loadingProgress.value > 100) loadingProgress.value = 100
    }
  }, 50) // Much faster intervals
  */
  
  // Info cards'ı initialize et
  updateInfoCards()
  
  // Clear any existing image tracking
  failedImages.clear()
  loadingImages.clear()
  imageCache.clear()
  
  // API verilerini yükle
  await loadApiData()
  
  // Image loading debug info
  console.log('🖼️ Image Loading System Initialized:', {
    failedImages: failedImages.size,
    loadingImages: loadingImages.size,
    imageCache: imageCache.size,
    defaultImages: Object.keys(defaultImages)
  })
  
  // Loading completion logic - DISABLED (uncomment to re-enable)
  /*
  setTimeout(() => {
    const checkComplete = setInterval(() => {
      if (loadingProgress.value >= 100) {
        clearInterval(checkComplete)
        clearInterval(progressInterval)
        
        setTimeout(() => {
          isLoading.value = false
          // Slider'ı loading sonrası başlat
          startSlideShow()
        }, 100)
      }
    }, 50)
  }, 300) // Minimum 0.3 seconds only
  */

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show-card')
        } else {
          entry.target.classList.remove('show-card')
        }
      })
    },
    { threshold: 0.2 }
  )
  
  // Statistics Observer
  const statsObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-stat')
          animateStats()
        }
      })
    },
    { threshold: 0.5 }
  )

  setTimeout(() => {
    projectCards.value.forEach((el) => {
      observer.observe(el)
    })
    
    // Observe statistics
    const statsSection = document.querySelector('.statistics-section')
    if (statsSection) {
      statsObserver.observe(statsSection)
    }
  }, 100)
  
  // Add scroll event listener for parallax effect
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  // Clean up event listeners and observers
  
  if (slideInterval.value) {
    clearInterval(slideInterval.value)
  }
  
  if (imageObserver.value) {
    imageObserver.value.disconnect()
  }
  
  // Remove scroll event listener
  window.removeEventListener('scroll', handleScroll)
})

// About Section Statistics - from API or fallback




// Contact form functionality moved to footer

// Locale değiştiğinde tüm API verilerini ve UI bileşenlerini güncelle
watch(locale, async (newLocale) => {
  console.log('🌍 Locale changed to:', newLocale)
  
  // Info cards'ı hemen güncelle
  updateInfoCards()
  
  // API verilerini yeniden yükle (dil-spesifik içerik için)
  try {
    await loadApiData()
    console.log('✅ API data reloaded for new locale')
  } catch (error) {
    console.error('❌ Error reloading API data for new locale:', error)
  }
})


</script>

<style scoped>
/* Prevent page overflow */
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.home-container {
  max-width: 100%;
  overflow-x: hidden;
}

.custom-header {
  width: 100%;
  box-sizing: border-box;
}

/* Ensure all sections align within header width */
section {
  max-width: 100%;
  box-sizing: border-box;
}

/* Sticky header styles */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: var(--bg-primary);
  box-shadow: 0 2px 10px var(--shadow-medium);
  border-bottom: 2px solid var(--primary-gold);
}

.nav-menu ul {
  display: flex;
  gap: 20px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-menu ul li a {
  text-decoration: none;
  color: #333;
  font-weight: bold;
  transition: color 0.3s;
}

.nav-menu ul li a:hover {
  color: #007BFF;
}

.modern-lang-btn {
  border: none;
  background-color: transparent;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.3s;
}

.modern-lang-btn.active {
  color: #007BFF;
}

.modern-dark-mode-toggle {
  font-size: 18px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  transition: transform 0.3s;
}

.modern-dark-mode-toggle:hover {
  transform: scale(1.1);
}

.modern-menu-bar span {
  display: block;
  width: 25px;
  height: 3px;
  background-color: #333;
  margin: 5px 0;
  transition: background-color 0.3s;
}

.modern-menu-bar.menu-active span {
  background-color: #007BFF;
}

/* Additional styles for sections and containers */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

section {
  padding: 60px 0;
  overflow-x: hidden;
}

.hero-slider {
  padding: 0 !important;
}

/* Hero Menu Navigation */
.hero-menu-nav {
  position: absolute;
  left: 50px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.menu-items {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 15px;
  background: rgba(0, 0, 0, 0.7);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 15px 20px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 300px;
  backdrop-filter: blur(10px);
}

.menu-item:hover {
  background: rgba(247, 197, 45, 0.9);
  border-color: var(--primary-gold);
  transform: translateX(10px);
}

.menu-item.active {
  background: linear-gradient(135deg, var(--primary-gold), #f39c12);
  border-color: var(--primary-gold);
  box-shadow: 0 8px 25px rgba(247, 197, 45, 0.4);
}

.menu-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.menu-item.active .menu-icon {
  background: rgba(255, 255, 255, 0.3);
}

.menu-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
}

.menu-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}

.menu-subtitle {
  font-size: 12px;
  opacity: 0.8;
  line-height: 1.3;
}

/* Large Navigation Arrows */
.hero-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  backdrop-filter: blur(10px);
}

.hero-arrow:hover {
  background: var(--primary-gold);
  border-color: var(--primary-gold);
  transform: translateY(-50%) scale(1.1);
}

.hero-arrow.prev {
  right: 120px;
}

.hero-arrow.next {
  right: 40px;
}

/* Slide Indicator */
.slide-indicator {
  position: absolute;
  bottom: 40px;
  right: 40px;
  display: flex;
  align-items: center;
  gap: 15px;
  background: rgba(0, 0, 0, 0.6);
  padding: 12px 20px;
  border-radius: 25px;
  color: white;
  font-weight: 600;
  backdrop-filter: blur(10px);
  z-index: 10;
}

.indicator-line {
  width: 30px;
  height: 2px;
  background: var(--primary-gold);
  border-radius: 1px;
}

/* Responsive Hero Navigation */
@media (max-width: 1024px) {
  .hero-menu-nav {
    left: 30px;
  }
  
  .menu-item {
    min-width: 250px;
    padding: 12px 15px;
  }
  
  .hero-arrow {
    width: 60px;
    height: 60px;
    font-size: 20px;
  }
  
  .hero-arrow.prev {
    right: 100px;
  }
  
  .hero-arrow.next {
    right: 30px;
  }
}

@media (max-width: 768px) {
  .hero-menu-nav {
    display: none;
  }
  
  .hero-arrow {
    width: 50px;
    height: 50px;
    font-size: 18px;
  }
  
  .hero-arrow.prev {
    right: 80px;
  }
  
  .hero-arrow.next {
    right: 20px;
  }
  
  .slide-indicator {
    bottom: 20px;
    right: 20px;
    padding: 8px 15px;
  }
}

.info-section {
  background: var(--bg-secondary);
  padding: 0 0 80px 0;
}

.info-card {
  transition: transform 0.3s;
}

.info-card:hover {
  transform: translateY(-5px);
}

.feature-card {
  transition: transform 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.project-card {
  transition: transform 0.3s;
  position: relative;
  overflow: hidden;
}

.project-card-bordered {
  border: 1px solid rgba(201, 160, 64, 0.2);
  border-radius: 15px;
}

.project-card-bordered:hover {
  border-color: var(--primary-gold);
  box-shadow: 0 12px 35px rgba(201, 160, 64, 0.15);
}

.project-card:hover {
  transform: translateY(-5px);
}

.project-card:hover .project-hover-overlay {
  opacity: 1;
  visibility: visible;
}

.project-hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(247, 197, 45, 0.95) 0%, rgba(44, 62, 80, 0.9) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 10;
  cursor: pointer;
}

.project-details-btn {
  background: var(--primary-gold);
  color: var(--text-primary);
  border: 2px solid var(--primary-gold-dark);
  padding: 12px 24px;
  font-size: 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px var(--shadow-medium);
  pointer-events: none;
}

.project-details-btn:hover {
  background: var(--bg-primary);
  color: var(--secondary-dark);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--shadow-medium);
  border-color: var(--secondary-dark);
}

.news-card {
  transition: transform 0.3s;
}

.news-card:hover {
  transform: translateY(-5px);
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.contact-icon {
  font-size: 24px;
  margin-right: 10px;
}

.submit-btn {
  background: var(--gradient-primary);
  color: var(--text-primary);
  padding: 12px 24px;
  border: 2px solid var(--primary-gold-dark);
  border-radius: 25px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background: var(--primary-gold-light);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--shadow-medium);
}

/* Dark mode styles */
.dark-mode {
  background-color: #121212;
  color: #e0e0e0;
}

.dark-mode .custom-header {
  background-color: #1e1e1e;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.dark-mode .nav-menu ul li a {
  color: #e0e0e0;
}

.dark-mode .nav-menu ul li a:hover {
  color: #007BFF;
}

.dark-mode .submit-btn {
  background-color: #007BFF;
  color: #fff;
}

.dark-mode .submit-btn:hover {
  background-color: #0056b3;
}

/* Loading screen styles */
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
}

.solar-loader {
  width: 50px;
  height: 50px;
  border: 5px solid #007BFF;
  border-top: 5px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Modern Contact Section Styles */
.modern-contact-section {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 120px 0;
  position: relative;
  overflow: hidden;
}

.contact-wrapper {
  position: relative;
  z-index: 2;
}

.contact-header {
  text-align: center;
  margin-bottom: 80px;
}

.gradient-text {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6, #06b6d4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 60px;
  align-items: start;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.contact-info-grid-new {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.contact-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 24px;
  padding: 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-height: 320px;
}

.contact-card:hover {
  transform: translateY(-12px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.card-gradient-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  opacity: 0.8;
  transition: all 0.4s ease;
}

.address-card .card-gradient-bg {
  background: linear-gradient(135deg, #f59e0b, #f97316);
}

.phone-card .card-gradient-bg {
  background: linear-gradient(135deg, #10b981, #059669);
}

.email-card .card-gradient-bg {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
}

.hours-card .card-gradient-bg {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
}

.contact-card:hover .card-gradient-bg {
  height: 80px;
  opacity: 0.9;
}

.card-inner {
  position: relative;
  z-index: 2;
  padding: 32px 28px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-icon-large {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.contact-card:hover .card-icon-large {
  transform: scale(1.1);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
}

.card-icon-large svg {
  color: #4b5563;
}

.address-card:hover .card-icon-large svg {
  color: #f59e0b;
}

.phone-card:hover .card-icon-large svg {
  color: #10b981;
}

.email-card:hover .card-icon-large svg {
  color: #3b82f6;
}

.hours-card:hover .card-icon-large svg {
  color: #8b5cf6;
}

.contact-card h3 {
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: left;
}

.card-value {
  color: #4b5563;
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 24px;
  flex-grow: 1;
}

.card-action-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  padding: 12px 20px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  margin-top: auto;
}

.card-action-btn:hover {
  background: rgba(59, 130, 246, 0.2);
  transform: translateX(4px);
}

/* Phone List Styles */
.phone-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-grow: 1;
}

.phone-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(16, 185, 129, 0.1);
  padding: 16px 20px;
  border-radius: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.phone-item:hover {
  background: rgba(16, 185, 129, 0.2);
  border-color: rgba(16, 185, 129, 0.3);
  transform: translateX(4px);
}

.phone-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.phone-name {
  color: #1f2937;
  font-weight: 600;
  font-size: 1rem;
}

.phone-number {
  color: #10b981;
  font-weight: 700;
  font-size: 1.1rem;
}

.call-icon {
  font-size: 1.5rem;
  transition: transform 0.3s ease;
}

.phone-item:hover .call-icon {
  transform: scale(1.2);
}

/* Email List Styles */
.email-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
}

.email-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(59, 130, 246, 0.1);
  padding: 14px 18px;
  border-radius: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.email-item:hover {
  background: rgba(59, 130, 246, 0.2);
  border-color: rgba(59, 130, 246, 0.3);
  transform: translateX(4px);
}

.email-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.email-label {
  color: #6b7280;
  font-weight: 500;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.email-address {
  color: #3b82f6;
  font-weight: 600;
  font-size: 0.95rem;
}

.mail-icon {
  font-size: 1.3rem;
  transition: transform 0.3s ease;
}

.email-item:hover .mail-icon {
  transform: scale(1.2);
}

/* Working Hours Styles */
.hours-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-grow: 1;
}

.day-hours {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: rgba(139, 92, 246, 0.1);
  padding: 16px 20px;
  border-radius: 16px;
  transition: all 0.3s ease;
}

.day-hours:hover {
  background: rgba(139, 92, 246, 0.2);
  transform: translateX(4px);
}

.day-hours.weekend {
  background: rgba(239, 68, 68, 0.1);
}

.day-hours.weekend:hover {
  background: rgba(239, 68, 68, 0.2);
}

.days {
  color: #1f2937;
  font-weight: 600;
  font-size: 1rem;
}

.hours {
  color: #8b5cf6;
  font-weight: 700;
  font-size: 1.2rem;
}

.weekend .hours {
  color: #ef4444;
}

.card-icon-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 24px;
}

.card-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
  z-index: 2;
}

.icon-bg {
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border-radius: 20px;
  opacity: 0.2;
  filter: blur(8px);
}

.card-content h4 {
  color: #1e293b;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.card-content p {
  color: #64748b;
  font-size: 1rem;
  margin-bottom: 16px;
}

.contact-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
}

.contact-link:hover {
  color: #2563eb;
  transform: translateX(4px);
}

.arrow {
  transition: transform 0.3s ease;
}

.contact-link:hover .arrow {
  transform: translateX(4px);
}



.modern-contact-form {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
}

.form-header {
  text-align: center;
  margin-bottom: 40px;
}

.form-header h3 {
  color: #1e293b;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.form-header p {
  color: #64748b;
  font-size: 1.1rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.form-group {
  position: relative;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.input-wrapper {
  position: relative;
}

.modern-input,
.modern-textarea,
.modern-select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.8);
  font-size: 0.95rem;
  transition: all 0.3s ease;
  outline: none;
}

.modern-input:focus,
.modern-textarea:focus,
.modern-select:focus {
  border-color: #3b82f6;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.modern-textarea {
  resize: vertical;
  min-height: 100px;
  max-height: 150px;
}

.floating-label {
  position: absolute;
  top: -12px;
  left: 16px;
  background: white;
  padding: 0 8px;
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
}

.label-icon {
  font-size: 1rem;
}

.select-wrapper {
  position: relative;
}

.modern-select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 16px;
  padding-right: 48px;
}

.form-actions {
  margin-top: 24px;
  text-align: center;
}

.modern-submit-btn {
  position: relative;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 14px 36px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  width: 100%;
  max-width: 200px;
}

.modern-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(59, 130, 246, 0.4);
}

.modern-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
  z-index: 2;
}

.btn-icon.loading {
  animation: spin 1s linear infinite;
}

.btn-bg {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #2563eb, #7c3aed);
  transition: left 0.3s ease;
}

.modern-submit-btn:hover .btn-bg {
  left: 0;
}

/* Background Elements */
.contact-bg-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.bg-shape {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1));
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  top: 10%;
  left: 5%;
  width: 120px;
  height: 120px;
  animation-delay: 0s;
}

.shape-2 {
  top: 60%;
  right: 10%;
  width: 80px;
  height: 80px;
  animation-delay: 2s;
}

.shape-3 {
  bottom: 20%;
  left: 20%;
  width: 60px;
  height: 60px;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 40px;
    max-width: 800px;
  }
  
  .contact-info-grid-new {
    order: 2;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .modern-contact-form {
    max-width: 100%;
    order: 1;
  }
  
  .contact-card {
    min-height: 260px;
  }
}

@media (max-width: 768px) {
  .modern-contact-section {
    padding: 60px 0;
  }
  
  .gradient-text {
    font-size: 2.2rem;
  }
  
  .contact-info-grid-new {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .modern-contact-form {
    padding: 24px;
    border-radius: 16px;
  }
  
  .contact-card {
    min-height: 240px;
  }
  
  .card-inner {
    padding: 24px 20px;
  }
  
  .card-icon-large {
    width: 56px;
    height: 56px;
  }
  
  .contact-card h3 {
    font-size: 1.3rem;
  }
}

@media (max-width: 640px) {
  .phone-item,
  .email-item {
    flex-direction: column;
    text-align: center;
    gap: 8px;
  }
  
  .phone-info,
  .email-info {
    align-items: center;
  }
}

/* Dark Mode Support */
.dark-mode .modern-contact-section {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
}

.dark-mode .modern-info-card {
  background: rgba(30, 41, 59, 0.8);
  border-color: rgba(255, 255, 255, 0.1);
}

.dark-mode .modern-contact-form {
  background: rgba(30, 41, 59, 0.9);
  border-color: rgba(255, 255, 255, 0.1);
}

.dark-mode .modern-input,
.dark-mode .modern-textarea,
.dark-mode .modern-select {
  background: rgba(15, 23, 42, 0.8);
  border-color: rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
}

.dark-mode .floating-label {
  background: #1e293b;
  color: #94a3b8;
}

/* Projects Section Enhancements */
.projects-footer {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  padding: 20px 0;
}

.all-projects-btn {
  background: linear-gradient(135deg, var(--primary-gold) 0%, #d4af37 100%);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(201, 160, 64, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 200px;
  justify-content: center;
}

.all-projects-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(201, 160, 64, 0.4);
  background: linear-gradient(135deg, #d4af37 0%, var(--primary-gold) 100%);
}

.all-projects-btn:active {
  transform: translateY(-1px);
}

.all-projects-btn i {
  transition: transform 0.3s ease;
  font-size: 14px;
}

.all-projects-btn:hover i {
  transform: translateX(4px);
}

/* Responsive Design for Projects Button */
@media (max-width: 768px) {
  .all-projects-btn {
    padding: 14px 28px;
    font-size: 14px;
    min-width: 180px;
  }
  
  .projects-footer {
    margin-top: 40px;
    padding: 15px 0;
  }
}

@media (max-width: 480px) {
  .all-projects-btn {
    padding: 12px 24px;
    font-size: 13px;
    min-width: 160px;
  }
}

/* Parallax Background Effects */
.parallax-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
  overflow: hidden;
}

.parallax-bg {
  position: absolute;
  width: 120%;
  height: 120%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.1;
  will-change: transform;
}

.parallax-bg1 {
  background-image: linear-gradient(45deg, 
    rgba(52, 152, 219, 0.3) 0%, 
    rgba(155, 89, 182, 0.3) 50%, 
    rgba(52, 73, 94, 0.3) 100%);
  top: -10%;
  left: -10%;
}

.parallax-bg2 {
  background-image: radial-gradient(circle at 30% 70%, 
    rgba(46, 204, 113, 0.2) 0%, 
    rgba(52, 152, 219, 0.2) 50%, 
    transparent 70%);
  top: -5%;
  right: -10%;
  width: 80%;
  height: 80%;
}

.parallax-bg3 {
  background-image: linear-gradient(135deg, 
    rgba(241, 196, 15, 0.2) 0%, 
    rgba(230, 126, 34, 0.2) 50%, 
    rgba(231, 76, 60, 0.2) 100%);
  bottom: -10%;
  left: 20%;
  width: 60%;
  height: 60%;
  border-radius: 50%;
}

/* Disable parallax on mobile for performance */
@media (max-width: 768px) {
  .parallax-container {
    display: none;
  }
}
</style>
